import { combineReducers, configureStore } from '@reduxjs/toolkit';
import partnerSlice from 'reducers/partnerReducer';
import shownPageSlice from 'reducers/shownPageReducer';
import generateCodeDetailsReducer from 'reducers/generateCodeDetailsReducer';
import partnerStatusSlice from 'reducers/partnerStatusReducer';
import memberCodeSlice from 'reducers/memberCodeReducer';
import modalReducer from 'reducers/modalReducer';
import memberCodeStatusSlice from 'reducers/memberCodeStatusReducer';
import accountSlice from 'reducers/accountReducer';
import mandateSlice from 'reducers/mandateReducer';
import caseSlice from 'reducers/caseReducer';
import userFeatureToggleSlice from 'reducers/userFeatureToggleReducer';
import videoIdentificationSlice from 'reducers/videoIdentificationReducer';
import clippPricingUrlsSlice from 'reducers/clippPricingReducer';
import eamEfaDashboardUrlsSlice from 'reducers/eamEfaDashboardReducer';
import productSlice from 'reducers/productReducer';
import serviceAgreementsReducer from 'reducers/serviceAgreementsReducer';
import appConfigReducer from 'reducers/appConfigReducer';
import tableReducer from 'reducers/tableReducer';
import portfolioReducer from 'reducers/portfolioReducer';
import productConfigurationReducer from 'reducers/productConfigurationReducer';
import productDocumentReducer from 'reducers/productDocumentReducer';
import privateBankingReducer from './reducers/privateBankingReducer';
import toastReducer from './reducers/toastReducer';

export const reducer = combineReducers({
  partner: partnerSlice,
  shownPage: shownPageSlice,
  generateCodeRequestDetails: generateCodeDetailsReducer,
  modal: modalReducer,
  partnerStatus: partnerStatusSlice,
  memberCode: memberCodeSlice,
  table: tableReducer,
  account: accountSlice,
  memberCodeStatus: memberCodeStatusSlice,
  mandate: mandateSlice,
  case: caseSlice,
  userFeatureToggles: userFeatureToggleSlice,
  videoIdentification: videoIdentificationSlice,
  clippPricingUrls: clippPricingUrlsSlice,
  eamEfaDashboardUrls: eamEfaDashboardUrlsSlice,
  product: productSlice,
  serviceAgreements: serviceAgreementsReducer,
  appConfig: appConfigReducer,
  portfolio: portfolioReducer,
  productConfiguration: productConfigurationReducer,
  productDocuments: productDocumentReducer,
  privateBanking: privateBankingReducer,
  toast: toastReducer,
});

export const store = configureStore({
  reducer: reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
